import React from "react";
import HeroSlider from "../components/HeroSlider";
// import AboutSection from "../components/AboutSection";
import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
// import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import ServiceIntro from "../components/Services/ServiceIntro";


const Services = () => {
  return (
    <> 
    <div>

        
      <HeroSlider />
      {/* <AboutSection/> */}
      <ServiceIntro/>
      <ServicesGrid />
      <BlogList/>
      {/* <Testimonials/> */}
      <Footer/>
     
    </div>
     </>
  );
};

export default Services;
